import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import rootReducer from './reducers';

let middleware = [];
if (process.env.NODE_ENV === 'development') {
  middleware = [thunk];
  console.log('%cStop!', 'color: red; font-size: 56px; font-weight: bold;')
    console.log(
      `%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a feature or "hack" someone's account, it is a scam and will give them access to your Audius account.`,
      'color: grey; font-size: 16px; font-weight: bold;'
    )
} else {
  middleware = [thunk];
  try {
    console.log('%cStop!', 'color: red; font-size: 56px; font-weight: bold;')
    console.log(
      `%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a feature or "hack" someone's account, it is a scam and will give them access to your Audius account.`,
      'color: grey; font-size: 16px; font-weight: bold;'
    )
    // console.log()
    console.log = () =>{}
    console.warn = () =>{}
  } catch (error) {

  }
}
const store =
  process.env.NODE_ENV === 'production'
    ? createStore(rootReducer, applyMiddleware(thunk))
    : createStore(
        rootReducer,
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
          window.__REDUX_DEVTOOLS_EXTENSION__(),
        applyMiddleware(...middleware)
      );

export default store;



// WEBPACK FOOTER //
// src/store/index.js